import React, { useState, useEffect } from "react";
import '../form.css';
// utils
import FormButton from "../../button/FormButton";
import CommonForm from '../CommonForm';
import { FormikTextInput } from "../../inputs/FormikInputs";
import CircularIndeterminate from '../../spinner/Spinner';
// validation
import { formikValidation } from './UsuarioContactoFormValidaciones';
// services
import { usuarioBasicosGet } from "../../../../services/hooli-services/EndUser/UsuarioBasicosGet";
import { usuarioContactoBOUpd } from "../../../../services/hooli-services/EndUser/UsuarioContactoBOUpd";
import { handleResponse } from "../../../../services/Local-services";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { userCredentials, formIsOpen, rowSelected, snackbarData, formData } from '../../../../recoilState/GlobalState'

export default function UsuarioContactoForm(props) {
    const [usuario, setUsuario] = useState();
    const [cargando, setCargando] = useState(true);
    const [newContacto, setNewContacto] = useState();
    const [inRequest, setInRequest] = useState(false);

    const setIsOpen = useSetRecoilState(formIsOpen);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const [selected, setSelected] = useRecoilState(rowSelected);
    const credentials = useRecoilValue(userCredentials);
    const data = useRecoilValue(formData);

    const { updateList } = props.props;

    async function retrieveUsuario() {
        const params = {
            "usuarioId": selected.row.id
        };
        const payload = { ...credentials, params };
        setCargando(true);
        const response = await usuarioBasicosGet(payload);
        setUsuario(response);
        setCargando(false);
    };

    async function handleAction() {
        if (!newContacto) return;
        const functions = { setSnackbarInfo, setInRequest, setIsOpen, setSelected, updateList };
        const params = {
            "usuarioId": selected.row.id,
            "usuarioMail": newContacto.email,
            "usuarioCelular": newContacto.telefono,
            "usuarioVersion": usuario?.usuarioVersion
        };
        const payload = { ...credentials, params };
        setInRequest(true);
        const response = await usuarioContactoBOUpd(payload);
        return handleResponse(response, 'Datos de contacto modificados exitosamente', functions);
    };

    useEffect(() => {
        if (selected.row?.id) retrieveUsuario();
    }, []);

    useEffect(() => {
        handleAction();
    }, [newContacto])

    const formik = formikValidation(setNewContacto, usuario);

    return (
        <CommonForm
            onSubmit={formik.handleSubmit}
            title={data.title}
        >
            {cargando ?
                <div style={{ minHeight: 140, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CircularIndeterminate customMargin={'0em'} />
                </div> :
                <>
                    <FormikTextInput
                        data={data}
                        name="email"
                        formik={formik}
                        disabled={inRequest}
                    />
                    <FormikTextInput
                        data={data}
                        name="telefono"
                        formik={formik}
                        disabled={inRequest}
                    />
                </>
            }
            <FormButton inRequest={inRequest} newDisabled={cargando || !usuario} />
        </CommonForm>
    );
};
